module.exports = __webpack_public_path__ + "static/img/active-shipping-credit-8.7e8eb86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/active-shipping-credit-8.png
// module id = 2epA
// module chunks = 134